
export default function IconLocation({ width, height }) {
  return (
    <svg
      enableBackground="new 0 0 32 32"
      height={height}
      width={width}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m16 1c-6.075 0-11 4.925-11 11 0 7 7.41 16.301 9 17.891.875.875 1.359 1.109 2 1.109s1.125-.234 2-1.109c1.59-1.59 9-10.891 9-17.891 0-6.075-4.925-11-11-11zm0 16c-2.761 0-5-2.239-5-5s2.239-5 5-5c2.762 0 5 2.239 5 5s-2.238 5-5 5z"></path>
    </svg>
  );
}
